// src/services/kolaybiFaturaService.js
import { getFunctions, httpsCallable } from 'firebase/functions';
const functions = getFunctions();

/**
 * 🧪 Kolaybi API Bağlantısını Test Et
 */
export const testKolaybiConnection = async () => {
  try {
    console.log('🧪 Kolaybi bağlantısı test ediliyor...');
    const testFunction = httpsCallable(functions, 'testKolaybiConnection');
    const result = await testFunction();
    console.log('✅ Test sonucu:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Test hatası:', error);
    return { 
      success: false, 
      error: error.message 
    };
  }
};

/**
 * 📄 E-Fatura Oluştur
 * @param {Object} invoiceData - Fatura bilgileri
 * @returns {Promise<Object>} Fatura sonucu
 */
export const createInvoice = async (invoiceData) => {
    try {
        console.log("📄 KolayBi E-Fatura oluşturuluyor:", {
            orderNumber: invoiceData.orderNumber,
            customerType: invoiceData.customerType,
        });
        const fn = httpsCallable(functions, "createKolaybiInvoice");
        const result = await fn(invoiceData);
        return result.data;
    } catch (error) {
        console.error("❌ KolayBi E-Fatura Hatası:", error);
        return {
            success: false,
            error:
                error?.details?.message ||
                error?.message ||
                "E-Fatura oluşturulamadı",
        };
    }
};
/**
 * 🔍 Fatura Sorgula
 * @param {string} invoiceId - Fatura ID
 * @returns {Promise<Object>} Fatura bilgileri
 */
// src/services/kolaybiFaturaService.js

/**
 * 🔍 Fatura Detay Al
 */
export const getInvoice = async (invoiceId) => {
    try {
        console.log('🔍 Fatura sorgulanıyor:', invoiceId);
        const getInvoiceFunction = httpsCallable(functions, 'getKolaybiInvoice');
        const result = await getInvoiceFunction({ invoiceId });
        console.log('✅ Fatura bilgisi alındı');
        return result.data;
    } catch (error) {
        console.error('❌ Fatura sorgulama hatası:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

/**
 * 📥 Fatura PDF İndir (Base64)
 */
// src/services/kolaybiFaturaService.js

export const downloadInvoicePDF = async (invoiceId) => {
    try {
        console.log('📥 Fatura PDF indiriliyor:', invoiceId);
        const downloadFunction = httpsCallable(functions, 'downloadKolaybiInvoicePDF');
        const result = await downloadFunction({ invoiceId });
        
        // ✅ Resmileştirilmemiş fatura kontrolü
        if (result.data.error === 'not_formalized') {
            return {
                success: false,
                error: result.data.message,
                details: result.data.details
            };
        }
        
        if (result.data.success && result.data.pdfBase64) {
            const byteCharacters = atob(result.data.pdfBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            
            window.open(url, '_blank');
            setTimeout(() => URL.revokeObjectURL(url), 100);
            
            return { success: true };
        }
        
        return { success: false, error: 'PDF data alınamadı' };
        
    } catch (error) {
        console.error('❌ PDF indirme hatası:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

/**
 * 🗑️ Fatura İptal Et
 */
export const cancelInvoice = async (invoiceId) => {
    try {
        console.log('🗑️ Fatura iptal ediliyor:', invoiceId);
        const cancelFunction = httpsCallable(functions, 'cancelKolaybiInvoice');
        const result = await cancelFunction({ invoiceId });
        console.log('✅ Fatura iptal edildi');
        return result.data;
    } catch (error) {
        console.error('❌ Fatura iptal hatası:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

/**
 * 📋 Faturaları Listele
 */
export const listInvoices = async (filters = {}) => {
    try {
        console.log('📋 Faturalar listeleniyor:', filters);
        const listFunction = httpsCallable(functions, 'listKolaybiInvoices');
        const result = await listFunction(filters);
        console.log('✅ Fatura listesi alındı');
        return result.data;
    } catch (error) {
        console.error('❌ Fatura listeleme hatası:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default {
    createInvoice,
    getInvoice,
    downloadInvoicePDF,
    cancelInvoice,
    listInvoices
};